<h2 mat-dialog-title>{{ 'scim-administration.policies.detail.title' | translate }}</h2>
<mat-dialog-content>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.policies.columns.name' | translate }}</strong>
		</label>
		<p>{{ policy.name }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.policies.columns.type' | translate }}</strong>
		</label>
		<p>{{ policy.type }}</p>
	</div>
	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.policies.columns.description' | translate }}</strong>
		</label>
		<p>{{ policy.description || '-' }}</p>
	</div>

	<div class="detail-field">
		<label>
			<strong>{{ 'scim-administration.policies.detail.permissions' | translate }}</strong>
		</label>
		@if (isLoadingPermissions) {
			<div style="padding: 12px 0">
				<img class="spinner" src="./assets/spinner2.gif" style="width: 24px; height: 24px" />
			</div>
		}
		@if (!isLoadingPermissions && permissionGroups.length === 0) {
			<div>
				<p class="empty-state">
					{{ 'scim-administration.policies.detail.noPermissions' | translate }}
				</p>
			</div>
		}
		@for (group of permissionGroups; track group.serviceName) {
			<div class="permission-group">
				<h4 style="margin: 16px 0 8px 0; padding: 8px 12px; background-color: #f0f0f0; border-radius: 4px; border-left: 3px solid #3f51b5; font-weight: 600">
					{{ group.serviceName }}
				</h4>
				<ul>
					@for (permission of group.permissions; track permission.name) {
						<li>
							<strong>{{ permission.name }}</strong>
						</li>
					}
				</ul>
			</div>
		}
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-button (click)="onClose()">
		{{ 'scim-administration.policies.detail.close' | translate }}
	</button>
</mat-dialog-actions>
